import { SideBarService } from "./side-bar.service";
import { ActivatedRoute, Router } from "@angular/router";
import { OnInit, Directive } from "@angular/core";

@Directive()
export class SideBarComponent implements OnInit{
    public sideBarOpened : boolean = false;

    constructor(
      protected sideBarService: SideBarService,
      protected router: Router,
      protected route: ActivatedRoute
    ) { }
  
    ngOnInit() {
      this.sideBarService.sideBarOpened.subscribe(res => this.sideBarOpened = res);
    }
  
    closeSlideBar(){
      this.router.navigate([
        {
        outlets: {
          sidebar: null,
          basket: null
        }
      }], {
        relativeTo: this.route
      }).then(res => {
        this.sideBarService.close();
      }, error => {
  
      })
    }
}
